import { render, staticRenderFns } from "./LifeInterestTrust.vue?vue&type=template&id=4266e252"
import script from "./LifeInterestTrust.vue?vue&type=script&lang=js"
export * from "./LifeInterestTrust.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports